import { render, staticRenderFns } from "./EmployeeBenefitsProviders.vue?vue&type=template&id=164dff6e&"
import script from "./EmployeeBenefitsProviders.vue?vue&type=script&lang=js&"
export * from "./EmployeeBenefitsProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports